import { makeResetStyles, mergeClasses } from '@fluentui/react-components';
import { tokens, typographyStyles } from '@fluentui-copilot/tokens';
import type { GroundingMenuErrorSlots, GroundingMenuErrorState } from './GroundingMenuError.types';
import type { SlotClassNames } from '@fluentui/react-components';

export const groundingMenuErrorClassNames: SlotClassNames<GroundingMenuErrorSlots> = {
  root: 'fai-GroundingMenuError',
  image: 'fai-GroundingMenuError__image',
  heading: 'fai-GroundingMenuError__heading',
  body: 'fai-GroundingMenuError__body',
};

const useRootClassName = makeResetStyles({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: tokens.spacingVerticalS,
  margin: 'auto',
  overflow: 'auto',
  maxHeight: '100%',
  width: '100%',
});
const useImageClassName = makeResetStyles({ width: '64px', height: '64px' });
const useHeadingClassName = makeResetStyles({
  ...typographyStyles.subtitle1,
});

/**
 * Apply styling to the GroundingMenuError slots based on the state
 */
export const useGroundingMenuErrorStyles_unstable = (state: GroundingMenuErrorState): GroundingMenuErrorState => {
  'use no memo';

  const rootClassName = useRootClassName();
  const imageClassName = useImageClassName();
  const headingClassName = useHeadingClassName();
  state.root.className = mergeClasses(groundingMenuErrorClassNames.root, rootClassName, state.root.className);

  if (state.image) {
    state.image.className = mergeClasses(groundingMenuErrorClassNames.image, imageClassName, state.image.className);
  }

  if (state.heading) {
    state.heading.className = mergeClasses(
      groundingMenuErrorClassNames.heading,
      headingClassName,
      state.heading.className,
    );
  }

  if (state.body) {
    state.body.className = mergeClasses(groundingMenuErrorClassNames.body, state.body.className);
  }

  return state;
};
